var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0047 7.5H34.4391V41.5669C31.2656 42.2182 28.0355 42.5542 24.7959 42.57C15.7172 42.5606 10.9922 38.505 10.9922 30.7162C10.9922 23.2162 16.0041 18.3412 23.7722 18.3412C24.8617 18.32 25.949 18.4461 27.0047 18.7163V7.5ZM27.0047 24.6412C26.1965 24.3746 25.3487 24.2478 24.4978 24.2663C20.7478 24.2663 18.5672 26.5594 18.5672 30.5775C18.5672 34.4906 20.6428 36.6506 24.4509 36.6506C25.3056 36.6504 26.1591 36.5878 27.0047 36.4631V24.6506V24.6412Z",
    fill: "url(#paint0_linear_1159_2610)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2487 18.8606V35.9231C46.2487 41.7975 45.8081 44.6212 44.5181 47.0568C43.2016 49.5334 41.0488 51.4622 38.4431 52.5L31.5469 49.2506C34.0522 48.3927 36.1506 46.6364 37.4363 44.3212C38.4975 42.2193 38.8331 39.7837 38.8331 33.3768V18.8606H46.2487Z",
    fill: "url(#paint1_linear_1159_2610)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2606 7.53748H38.8281V15.09H46.2606V7.53748Z",
    fill: "url(#paint2_linear_1159_2610)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1159_2610",
    x1: 10.9922,
    y1: 25.035,
    x2: 34.4391,
    y2: 25.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1159_2610",
    x1: 31.5469,
    y1: 35.6803,
    x2: 46.2487,
    y2: 35.6803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1159_2610",
    x1: 38.8281,
    y1: 11.3137,
    x2: 46.2606,
    y2: 11.3137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.d72f126b0a6021f3f917f065f07aa4dd.svg";
export { ForwardRef as ReactComponent };